var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLandingMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25586 31.2056L15.6868 0.794434H52.2072L38.1973 31.2056H1.25586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1817 0L0 32H38.7051L53.4459 0H15.1817ZM37.9106 21.1758C37.8709 21.3545 37.8113 21.573 37.7398 21.8669C37.6505 22.2657 37.5173 22.6534 37.3426 23.0228C37.0065 23.573 36.5123 24.0091 35.9245 24.2741L32.5402 26.3198L32.3098 26.4548L32.2304 26.5025C31.84 26.7325 31.4223 26.9127 30.9871 27.0387C30.7281 27.109 30.461 27.145 30.1927 27.146H16.9176V21.9821H32.4211L24.4449 17.3466C21.4975 15.6107 18.4469 13.8391 17.7875 13.4538L17.6723 13.3744H17.6524L17.4419 13.2473C17.2796 13.155 17.123 13.0529 16.9732 12.9414C16.5635 12.6725 16.2528 12.277 16.0886 11.8152C15.9244 11.3534 15.9156 10.8506 16.0636 10.3833L16.2344 9.69215C16.3237 9.29338 16.4569 8.90571 16.6316 8.53625C16.9688 7.987 17.4627 7.55123 18.0497 7.28501L21.434 5.2433L21.6643 5.10427L21.7438 5.0566C22.1342 4.82657 22.5519 4.64641 22.9871 4.52036C23.2461 4.45013 23.5132 4.41408 23.7815 4.41311H37.0566H37.0963V9.57696H21.5412L26.3078 12.3575C30.3913 14.7408 35.3486 17.5889 36.5243 18.292C36.6488 18.3688 36.764 18.4442 36.8699 18.5184L36.9017 18.5382C37.3428 18.7996 37.6825 19.2024 37.8657 19.6812C38.0488 20.1601 38.0647 20.6868 37.9106 21.1758ZM41.5452 7.86892H40.8103V4.44489H41.5452V7.86892ZM43.7577 5.08838V7.86892H43.0308V5.08838H41.9623V4.44489H44.7944V5.10824L43.7577 5.08838Z",
    fill: "url(#paint0_linear_13220_3340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13220_3340",
    x1: 7.93247,
    y1: 38.6574,
    x2: 45.7716,
    y2: -6.43893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A954FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#19C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLandingMobileIcon);
export default __webpack_public_path__ + "static/media/logo-landing-mobile-icon.0e50b8c81761e7710650e98c0379c648.svg";
export { ForwardRef as ReactComponent };